// extracted by mini-css-extract-plugin
export default {"pageTitle":"filterSection_pageTitle__6u5oR","desktop":"filterSection_desktop__ULqzN","modal":"filterSection_modal__PfTck","content":"filterSection_content__5gLQ5"};